// extracted by mini-css-extract-plugin
module.exports = {"section":"AppSection_section__1_7I8"};